/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Pipe, PipeTransform } from '@angular/core';

/**
 * @export
 * @class LocoBlankString
 * @implements {PipeTransform}
 */
@Pipe({
    name: 'locoBlankString',
    pure: false
})
export class LocoBlankString implements PipeTransform {


    /**
     * This Method is used to return - in case of null or blank String
     * @param {string} value
     * @returns {string}
     * @memberOf LocoBlankString
     */
    transform(value: string): string {
        if (!value || value === '') {
            return '-';
        } else {
            return value;
        }
    }
}
